/** Accessible `?` tooltip (hover + keyboard focus). Used to make "חימום" self-explanatory. */
export function Tooltip({ text }: { text: string }): JSX.Element {
  return (
    <span className="tt">
      <button type="button" className="q" aria-label={text} tabIndex={0}>?</button>
      <span className="bubble" role="tooltip">{text}</span>
    </span>
  );
}

/** The canonical warm-up explainer copy (reused wherever "שלב הרצה" appears). */
export const WARMUP_TIP =
  'שלב הרצה = מספר חדש מתחיל בשליחה קטנה וגדל בהדרגה לאורך כ-4 שבועות, כדי שלא ייחסם.';
